import Link from 'next/link';
import type { FC } from 'react';
import { ChevronDownIcon } from 'xyz-icon-set-react/dist/icons/ChevronDownIcon';
import { Typography } from '../Typography';
import { BreadcrumbItem } from './BreadcrumbItem';
import styles from './Breadcrumb.module.css';

export interface BreadcrumbItemType {
  label: string;
  href?: string;
}

export interface BreadcrumbProps {
  items?: BreadcrumbItemType[];
}

const BreadcrumbComponent: FC<BreadcrumbProps> & {
  Item: typeof BreadcrumbItem;
} = ({ items }) => {
  return (
    <div className={styles.root}>
      <BreadcrumbItem>
        <Link className={styles.link} href="/">
          <Typography.Caption size="L" fontWeight={600}>
            Ondřej Bárta
          </Typography.Caption>
        </Link>
      </BreadcrumbItem>

      {items &&
        items.map((item, index) => (
          <BreadcrumbItem key={index}>
            <div className={styles.chevron}>
              <ChevronDownIcon />
            </div>

            {item.href ? (
              <Link className={styles.link} href={item.href}>
                <Typography.Caption size="L" fontWeight={600}>
                  {item.label}
                </Typography.Caption>
              </Link>
            ) : (
              <span className={styles.link}>
                <Typography.Caption size="L" fontWeight={600}>
                  {item.label}
                </Typography.Caption>
              </span>
            )}
          </BreadcrumbItem>
        ))}
    </div>
  );
};

BreadcrumbComponent.Item = BreadcrumbItem;

export const Breadcrumb = BreadcrumbComponent;
